(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  const productMobileTitle = document.querySelector('.product-mobile-title');
  // sticky header
  var prevScrollpos = window.pageYOffset;
  var windowWidth = window.innerWidth;
  var mobileBreakpoint = document.querySelector('nav#main-menu').dataset.mobileBreakpoint;

  const setHeaderShowHide = () => {
    var currentScrollPos = window.pageYOffset;
    var breakpointValue = parseInt(mobileBreakpoint.replace('px', ''));
    var hideHeaderBelowScrollLevel1 = windowWidth < breakpointValue ? 50 : 300;
    var hideHeaderBelowScrollLevel2 = windowWidth < breakpointValue ? 50 : 600;
    // console.log('breakpointValue:', breakpointValue);
    // Add header-top class when window viewport is at top of page...
    if (currentScrollPos >= hideHeaderBelowScrollLevel1) {
      productMobileTitle?.classList.remove('header-showing');
      document.body.classList.remove('header--top');
    } else {
      productMobileTitle?.classList.add('header-showing');
      document.body.classList.add('header--top');
    }

    // // retain header showing till 500px down the page...
    // if (currentScrollPos >= 500) {
    //   productMobileTitle?.classList.remove('header-showing');
    //   document.body.classList.remove('header-showing');
    // } else {
    //   productMobileTitle?.classList.add('header-showing');
    //   document.body.classList.add('header-showing');
    // }

    // hide and show based on scroll direction...
    if (prevScrollpos > currentScrollPos || currentScrollPos < hideHeaderBelowScrollLevel2) {
      productMobileTitle?.classList.add('header-showing');
      document.querySelector('header.section-header').classList.remove('hide');
      document.body.classList.add('header-showing');
    } else {
      productMobileTitle?.classList.remove('header-showing');
      document.querySelector('header.section-header').classList.add('hide');
      document.body.classList.remove('header-showing');
    }
    prevScrollpos = currentScrollPos;
  };

  window.onscroll = function () {
    setHeaderShowHide();
  };

  window.onresize = function () {
    windowWidth = window.innerWidth;
    setHeaderShowHide();
  };

  setHeaderShowHide();

  } catch(e) { console.error(e); }
})();
})();
